var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWoWSelectorLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 8.674,
    width: 3.871,
    height: 2.581,
    rx: 1.29,
    fill: "#191937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.28a8.28 8.28 0 100-16.56 8.28 8.28 0 000 16.56zM10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#CDDCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29 2.437v2.796l2.653-2.796H1.29zM18.638 17.778v-2.796l-2.652 2.796h2.652zM18.638 2.437v2.796l-2.652-2.796h2.652zM1.29 17.778v-2.796l2.653 2.796H1.29zM3.8 4.946h3.297l-.072 1.398 1.326 6.308 1.757-6.989 1.792 6.99 1.182-6.954v-.323c-.035-.12-.136-.372-.25-.43H16.2c-.31.442-.96 1.47-1.075 2.043-.115.574-.98 5.807-1.398 8.351v.287c.107.323.344.968.43.968H10.68c.096-.203.258-.774.143-1.434-.114-.66-.477-2.282-.645-3.01-.19.884-.595 2.76-.68 3.19-.087.43.107 1.015.214 1.254H6.201c.545-.516.61-1.051.573-1.254L4.552 5.986c-.115-.488-.55-.896-.753-1.04z",
    fill: "#CDDCFE"
  })));
}
export default __webpack_public_path__ + "static/svg/WoW-SelectorLogo.svg";
export { SvgWoWSelectorLogo as ReactComponent };